import React from 'react';
import { DroneContext } from ".";
import { DroneStatusType } from '@src/core/features/drone/entities';

export const useDroneProvider = (status?: DroneStatusType) => {
  const { data, isLoading, refetch } = React.useContext(DroneContext);

  const drones = React.useMemo(() => {
    if (status) {
      return data.filter((drone) => drone.status === status) ?? [];
    }
    return data;
  }, [data, status]);

  return {
    drones,
    refetch,
    isLoading,
  };
};